import { useEffect } from 'react';
import { useUser } from '../contexts/useUser';
import { announcements } from '../data/announcements';
import { useNotificationStore } from '../state/notifications';

const AnnouncementNotifier: React.FC = () => {
  const { user } = useUser();
  const { addNotification } = useNotificationStore();

  useEffect(() => {
    if (!user) return;

    let shown: string[] = [];
    try {
      shown = JSON.parse(localStorage.getItem('shownAnnouncements') || '[]');
    } catch {
      shown = [];
    }

    const updated = [...shown];
    announcements.forEach((a) => {
      if (!shown.includes(a.id)) {
        addNotification({ id: a.id, title: a.title, body: a.description });
        updated.push(a.id);
      }
    });

    if (updated.length !== shown.length) {
      localStorage.setItem('shownAnnouncements', JSON.stringify(updated));
    }
  }, [user, addNotification]);

  return null;
};

export default AnnouncementNotifier;
